import { ExpandMore, ExpandLess } from "@mui/icons-material";
import React from "react";

import type { SidebarMenuItemCollapseIconProps } from "./types";

// Personalizza questo colore
const ICON_COLOR = "#94a3b8"; // Colore icone (grigio medio)

export const SidebarMenuItemCollapseIcon: React.FC<
  SidebarMenuItemCollapseIconProps
> = ({ isExpanded }) => {
  return isExpanded ? (
    <ExpandLess
      sx={{
        transition: "transform 0.2s",
        transform: "rotate(180deg)",
        color: ICON_COLOR,
        fontSize: 24,
      }}
    />
  ) : (
    <ExpandMore
      sx={{
        transition: "transform 0.2s",
        transform: "rotate(270deg)",
        color: ICON_COLOR,
        fontSize: 24,
      }}
    />
  );
};
